import { ApiSchema } from '../lib/query/apiClient';
import { UserStatus } from '../models';
import { ActionMap } from '../types';

type UserDto = ApiSchema<'UserDto'>;

export type UserState = {
  currentUser: UserDto;
  status: UserStatus;
};

const initialUser: UserDto = {
  accountType: 'Personal',
  accountPublicId: '',
  displayName: '',
  emailAddress: '',
  companyName: '',
  hasRoles: false,
  isContactInformationVerified: false,
};

export const initialUserState: UserState = {
  currentUser: initialUser,
  status: UserStatus.LOGGED_OUT,
};

export enum UserActionTypes {
  ResetUser = 'RESET_USER',
  SetUser = 'SET_USER',
  SetStatus = 'SET_USER_STATUS',
}

// User

type UserPayload = {
  [UserActionTypes.ResetUser]: undefined;
  [UserActionTypes.SetUser]: UserDto;
  [UserActionTypes.SetStatus]: UserStatus;
};

export type UserActions = ActionMap<UserPayload>[keyof ActionMap<UserPayload>];

export const userReducer = (state: UserState, action: UserActions) => {
  switch (action.type) {
    case UserActionTypes.SetUser:
      return {
        ...state,
        currentUser: action.payload,
      };
    case UserActionTypes.ResetUser:
      return {
        ...state,
        currentUser: initialUser,
      };
    case UserActionTypes.SetStatus:
      return {
        ...state,
        status: action.payload,
      };
    default:
      return state;
  }
};
